var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1899_2174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3341 12.5C25.3341 5.59648 19.7374 0 12.8337 0C5.92997 0 0.333313 5.59639 0.333313 12.5C0.333313 18.7391 4.90454 23.9104 10.8805 24.8481V16.1133H7.70658V12.5H10.8805V9.74609C10.8805 6.61328 12.7468 4.88281 15.602 4.88281C16.9698 4.88281 18.4003 5.12695 18.4003 5.12695V8.20312H16.824C15.2711 8.20312 14.7869 9.1667 14.7869 10.1553V12.5H18.2538L17.6996 16.1133H14.7869V24.8481C20.7628 23.9104 25.3341 18.7392 25.3341 12.5Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6996 16.1133L18.2538 12.5H14.7869V10.1553C14.7869 9.1666 15.2712 8.20312 16.8241 8.20312H18.4003V5.12695C18.4003 5.12695 16.9698 4.88281 15.6021 4.88281C12.7468 4.88281 10.8805 6.61328 10.8805 9.74609V12.5H7.7066V16.1133H10.8805V24.8481C11.5267 24.9494 12.1797 25.0002 12.8337 25C13.4877 25.0002 14.1408 24.9494 14.7869 24.8481V16.1133H17.6996Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1899_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.333313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5439c2d3aa564ac4f40814463b699156.svg";
export { ForwardRef as ReactComponent };